import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

/**
 * Public landing for a shareable Google Ads connect link. Deliberately outside
 * `_authenticated`: the Ads owner has no platform login.
 */
const ConnectorLandingPage = lazy(
  () => import('~/features/connector-share/pages/connector-landing-page'),
);

export const Route = createFileRoute('/connector/$token/')({
  component: () => (
    <Suspense fallback={null}>
      <ConnectorLandingPage />
    </Suspense>
  ),
});
